import React, { PureComponent } from 'react';
import PropTypes, { array } from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    Image,
    Platform
} from 'react-native';

import {
    JDTouchable,
    JDText,
    JDScrollView,
    JDLogin,
    JDPopupWindow
} from '@jdreact/jdreact-core-lib';

import { utils, NavBar, ImageList as ImageInfos } from '@ltfe/ltfe-core-lib';
import LoginBottom from '../components/common/login-bottom';
import TheatreAddr from '../components/common/theatre-addr';
import Loading from '../components/common/loading';
import NoMore from '../components/common/no-more';
import Share from '../components/right-share';
import WifiOut from '../components/common/wifi-out';
import Swiper from '../components/movieList/swiper/index';
import List from '../components/movieList/list';
import TabList from '../components/movieList/tab-list';
import Promotion from '../components/movieList/promotion';
import ScaleInfo from '../components/movieList/scale-info';

import st from '../style/movie.list.st';

import { get, post } from '../common/fetch';
import { mta, mtaPV, diff_date, date_str, is_web, saveLocal, fetchLocal } from '../common/utils';
import sgmReport from '../common/sgmUtil';

const { pt } = utils;

const img = require('../common/img');

/**
 * 场次列表页
 */
class MovieList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            // 选择日期
            theDate: this.props.theDate,
            // 影片列表
            filmList: [
                {
                    movieId: '',
                    movieName: '',
                    jdPicUrl: '',
                    movieType: '',
                    grade: '',
                    movieLength: '',
                    area: '',
                    language: ''
                }
            ],

            // filmList: [
            //     // {
            //     //     movieId: '49727',
            //     //     movieName: '清水里的刀子',
            //     //     jdPicUrl: 'https://p0.meituan.net/movie/6bd2f8055be0f72c2ad1df58c36a6cd53769942.jpg',
            //     //     movieType: '剧情',
            //     //     grade: '0.0',
            //     //     movieLength: '93',
            //     //     area: '中国大陆',
            //     //     language: '荷兰语/ 英语/ 德语'
            //     // }
            // ],
            //   影院信息
            cinemaInfoVO: {
                cinemaId: '',
                cinemaName: '',
                cityId: '',
                regionId: '',
                regionName: '',
                address: '',
                telephoneNum: '',
                lon: '',
                lat: '',
                agentId: ''
            },

            // cinemaInfoVO: {
            //     // cinemaId: '88098',
            //     // cinemaName: '金逸院线新恒星影城',
            //     // cityId: '31',
            //     // regionId: '300043',
            //     // regionName: '闸北区',
            //     // address: '闸北区西藏北路166号大悦城10-11楼(近曲阜路',
            //     // telephoneNum: '021-36397050',
            //     // lon: '121.47158',
            //     // lat: '31.24239',
            //     // agentId: '781978'
            // },
            // 当前选择影片
            theMovie: {
                // "movieId": "49691",
                // "movieName": "雪·葬",
                // "jdPicUrl": "//img30.360buyimg.com/test/jfs/t34/309/987517388/479424/ff35679e/5b20b530Nefdab166.jpg",
                // "movieType": "剧情",
                // "grade": "0.0",
                // "movieLength": "105",
                // "area": "中国大陆",
                // "language": "汉语普通话"
            },
            /* 轮播图参数 start */
            theMovieId: null,
            picUrl: null,
            /* 轮播图参数 end */
            // 日期列表
            showTimes: [],
            // 场次列表
            planList: [],
            // 促销信息
            promoTypes: [],
            // 订单详情及电影信息loading
            loading: false,
            // 场次列表loading
            listLoading: false,
            // 登录状态
            isLogin: false,
            // 促销弹层
            scaleShow: false,
            // 分享信息
            shareInfo: {},
            hasError: false,
            btnTxt: null,
            nextDate: null,
            // 是否展示哈尔滨国补优惠View
            govSubsidy: "false", 
            govSubsidyText: '',// 哈尔滨政府补贴筛选项文案，不同时间段不同
            govSubsidyTag: '', // 哈尔滨政府补贴筛选项Tag，不同时间段不同
        };
        this.getInfo = this.getInfo.bind(this);
        this._changeDate = this._changeDate.bind(this);
        this._goBuy = this._goBuy.bind(this);
        this._login = this._login.bind(this);
        this._onHide = this._onHide.bind(this);
        this._showPromotion = this._showPromotion.bind(this);
        this._setMovieId = this._setMovieId.bind(this);
        this.refresh = this.refresh.bind(this);
        this.nextDate = this.nextDate.bind(this);

        this.onPress = this.onPress.bind(this);
        this.onScrollEnd = this.onScrollEnd.bind(this);
        this.renderItem = this.renderItem.bind(this);
    }

    // static defaultProps = { "cinemaId": 43563, "movieId": "77063" }

    render() {
        const { theDate, cinemaInfoVO, movieList, theMovie, showTimes, planList, loading, listLoading, isLogin, scaleShow, shareInfo, promoTypes, promoDesc, btnTxt } = this.state;
        const { theMovieId, picUrl, hasError, dataLoading, govSubsidy, govSubsidyText, govSubsidyTag } = this.state;

        const title = cinemaInfoVO && cinemaInfoVO.cinemaName.length > 10 ? cinemaInfoVO.cinemaName.slice(0, 10) + '...' : cinemaInfoVO.cinemaName;

        /* 初始化swiper */
        let listIndex = 0;

        let indexPicUrl = movieList ? movieList[0].jdPicUrl : null;

        const TheMovieId = this.props.movieId || fetchLocal('theMovieId');
        // if (this.props.movieId && !picUrl) {

        if (TheMovieId && !picUrl) {
            movieList && movieList.forEach((val, index) => {
                if (val.movieId == TheMovieId) {
                    listIndex = index;
                    indexPicUrl = val.jdPicUrl;
                }
            });
        }

        if (hasError) {
            return (
                <View style={ st.context }>
                    {this.setTitle('选择场次')}
                    <WifiOut refresh={ this.refresh } contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                    {/* 开场提示 */}
                    {/* <OpeningHint ref={(hint) => this._hint = hint} /> */}
                </View>
            );
        }

        // if (!loading) {
        return (
            <View style={ st.context }>
                {
                    !loading
                        ? <View style={ st.context }>
                            {this.setTitle('选择场次')}
                            <Loading contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                        </View>
                        : <View style={ [st.context, st.c_context] } >

                            {!is_web ? <NavBar title={ title } rightButton={ shareInfo.title ? <Share shareInfo={ shareInfo } /> : null } /> : this.setTitle(title)}

                            <JDScrollView style={ st.context }
                                showsVerticalScrollIndicator={ false }>
                                <View style={ st.context }>
                                    <View style={ st.context }>

                                        <TheatreAddr
                                            addrInfo={ {
                                                cinemaId: cinemaInfoVO.cinemaId,
                                                tel: cinemaInfoVO.telephoneNum,
                                                cinemaName: cinemaInfoVO.cinemaName,
                                                address: cinemaInfoVO.address,
                                                lng: cinemaInfoVO.lon,
                                                lat: cinemaInfoVO.lat,
                                                cinemaTag: cinemaInfoVO.cinemaTag
                                            } } />

                                        {/* { */}
                                        {/* Platform.OS == 'ios' ? */}
                                        {/* <MovieSwiper movieList={movieList} setMoveId={this._setMovieId} theMovie={theMovie} /> */}
                                        {/* : */}
                                        <View style={ { height: pt(142), width: pt(375) } } >
                                            <Image imageStyle={ { resizeMode: 'cover' } } source={ { uri: picUrl || indexPicUrl } } blurRadius={ Platform.OS == 'ios' ? 5 : 0.5 } style={ st.brief } />

                                            <Swiper
                                                style={ { height: pt(142), width: pt(375), backgroundColor: 'transparent', zIndex: 100 } }
                                                data={ movieList }
                                                renderItem={ this.renderItem }
                                                listIndex={ listIndex }
                                                // unitWidth={pt(65)}
                                                // unitHeight={pt(88)}
                                                // maxWidth={pt(86)}
                                                // maxHeight={pt(124)}
                                                // wrapWidth={pt(90)}
                                                onPress={ this.onPress }
                                                onScrollEnd={ this.onScrollEnd }
                                            />
                                        </View>
                                        {/* } */}

                                        {/* 影片信息 */}
                                        <JDTouchable onPress={ () => {
                                            this.context.router.toMovieDetail({ movieId: theMovie.movieId });
                                            mta('TicketMovInfo', 'Detail', `${theMovie.jSkuId}_${theMovie.movieId}`);
                                        } }>
                                            <View style={ st.movie_main }>
                                                <View style={ st.info }>
                                                    <JDText style={ st.title }>{theMovie.movieName}</JDText>
                                                    {
                                                        theMovie.grade > 0
                                                            ? <JDText style={ st.addrtxt }>观众评分 {theMovie.grade} </JDText>
                                                            : <JDText style={ st.addrtxt }>暂无评分</JDText>
                                                    }
                                                </View>
                                                <View>
                                                    <JDText style={ st.movie_txt }>{theMovie.area} | {theMovie.movieLength > 0 && <JDText>{theMovie.movieLength}分钟</JDText>} {theMovie.movieType && theMovie.movieType.indexOf('|') > 0 ? theMovie.movieType.replace(/\|/g, '/') : theMovie.movieType}</JDText>
                                                </View>
                                            </View>
                                        </JDTouchable>

                                        <View style={ { height: pt(5), backgroundColor: '#f2f2f2' } } />

                                        {dataLoading && <TabList
                                            changeDate={ this._changeDate }
                                            issueList={ showTimes }
                                            movieId={ theMovie.movieId }
                                            theDate={ theDate }
                                        />}

                                        {listLoading && promoTypes.length > 0 && <Promotion promoTypes={ promoTypes } promoDesc={ promoDesc } scaleFn={ this._showPromotion } govSubsidy={govSubsidy} govSubsidyText={govSubsidyText} govSubsidyTag={govSubsidyTag}/>}

                                        {/* 场次列表 */}
                                        {
                                            !listLoading
                                                ? <Loading loadingTxt={ '场次列表加载中' } contentStyle={ { marginTop: pt(dataLoading ? 60 : 90) } } />
                                                : planList.length > 0
                                                    ? <JDScrollView showsVerticalScrollIndicator={ false }>

                                                        <List listLoading={ listLoading } isLogin={ isLogin } planList={ planList } goBuy={ this._goBuy } />
                                                    </JDScrollView>

                                                    : <View style={ st.c_context }>

                                                        {
                                                            btnTxt
                                                                ? <NoMore img={ img.no_list } txt='当日暂无可售场次' btnTxt={ `查看${btnTxt}场次` } btnFn={ this.nextDate } />
                                                                : <NoMore img={ img.no_list } txt='当日暂无可售场次' />
                                                        }
                                                    </View>
                                        }
                                    </View>

                                    <View>
                                        <ImageInfos code={ '97720bb285d747c9b5e924cfd2bb299b' } mode={ 'pro' } channel='movie' />
                                    </View>

                                    {!isLogin && <View style={ { height: pt(40), backgroundColor: '#fff' } } />}

                                </View>
                            </JDScrollView>

                            {!isLogin && <LoginBottom login={ this._login } />}

                            {/* 弹层 */}
                            {scaleShow && <JDPopupWindow show={ scaleShow } onHide={ this._onHide } >

                                <View style={ { backgroundColor: '#fff' } } >
                                    <ScaleInfo key={ 1 } promoTypes={ promoTypes } />
                                </View>

                            </JDPopupWindow>}

                        </View>
                }
                {/* 开场提示 */}
                {/* <OpeningHint ref={(hint) => this._hint = hint} /> */}
            </View>
        );
        // }
    }

    componentDidMount() {
        if (is_web) {
            const selectedSeat = fetchLocal('selectedSeat');
            const planId = fetchLocal('planId');
            if (selectedSeat != null) {
	              const { scheduledPlay = '0' } = this.props;
                get('releaseSeat', {
									planId,
	                selectedSeat,
	                scheduledPlay: +scheduledPlay
								}).then((res) => { });

                if(!planId || !selectedSeat || !(+scheduledPlay)){
                    sgmReport('1001', {function_id: 'releaseSeat',message:'缺少参数planId/selectedSeat/scheduledPlay'}, 3)
                }
            };
            localStorage.removeItem('selectedSeat');
        }
    }

    componentDidFocus() {
        const { cinemaId, movieId = '', userPin, skuId = '' } = this.props;

        const { theMovie } = this.state;

        this.getInfo(theMovie.movieId || movieId).then(() => {
            // pv
            mtaPV('Detail', `${this.state.theMovie.movieId || movieId}_${cinemaId}_${this.state.theMovie.jSkuId || skuId}`);
        });

        JDLogin.isLogin().then(re => {
            this.setState({
                isLogin: true
            });
        }).catch((e) => {
            console.log(e);
        });
        this.initCity();
        // 开场提示
        // this._hint.hintStorage();
    }

    componentWillUnmount() {
        /* 用于清空当前影片导致的进别的影院swiper未渲染的情况 */
        this.setState({
            theMovie: { movieId: null }
        });
    }

    initCity = () => {
        const { movieId, cinemaId, skuId = '' } = this.props;
        const { theMovie } = this.state;

        const a = fetchLocal('theMovieId');

        const TheMovieId = theMovie.movieId || movieId || a;
        // 与历史城市对比

        storage.load({
            key: 'movieCityHistory'
        }).then(hisres => {
            if (hisres) {
                // 有历史记录
                this.props.dispatch({
                    type: 'cur_city',
                    cur_city: hisres[0]
                });
                this.getInfo(TheMovieId, hisres[0].cityId).then(() => {
                    mtaPV('Detail', `${this.state.theMovie.movieId || movieId}_${cinemaId}_${this.state.theMovie.jSkuId || skuId}`);
                });
            }
        }).catch(() => {
            this.getInfo(TheMovieId).then(() => {
                mtaPV('Detail', `${this.state.theMovie.movieId || movieId}_${cinemaId}_${this.state.theMovie.jSkuId || skuId}`);
            });
        });
    }

    onPress(movie, index) {
        const { cinemaId } = this.props;

        const { theMovie, movieList } = this.state;

        if (theMovie.movieId == movie.movieId) {
            this.context.router.toMovieDetail({ movieId: movie.movieId });

            return;
        }
        this.setState({
            theMovie: movie,
            theMovieId: movie.movieId,
            picUrl: movieList[index].jdPicUrl,
            dataLoading: false,
            listLoading: false
        });
        saveLocal('theMovie', movie);
        saveLocal('theMovieId', movie.movieId);
        // if(theMovie.movieId == movie.movieId)return
        this.getMovieDate(cinemaId, movie.movieId);
        // this.getInfo(movieId)
    }

    onScrollEnd(movie, index) {
        const { cinemaId } = this.props;
        const { theMovie, movieList } = this.state;

        if (theMovie.movieId == movie.movieId) return;
        this.setState({
            theMovie: movie,
            theMovieId: movie.movieId,
            picUrl: movieList[index].jdPicUrl,
            dataLoading: false,
            listLoading: false
        });
        saveLocal('theMovie', movie);
        saveLocal('theMovieId', movie.movieId);
        // if(theMovie.movieId == movie.movieId)return
        this.getMovieDate(cinemaId, movie.movieId);
        // this.getInfo(movieId)
    }

    renderItem(item, index) {
        return <Image source={ { uri: item.jdPicUrl } } style={ {
            width: '100%',
            height: '100%',
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3
        } } />;
    }

    /* 关闭弹层（促销） */
    _onHide() {
        this.setState({
            scaleShow: false
        });
    }

    /* 打开弹层（促销） */
    _showPromotion() {
        this.context.router.toActivity({ ruleIds: this.state.ruleIds });
        // if (this.state.promoTypes.length <= 1) return;
        // this.setState({
        //     scaleShow: true,
        // });
    }

    // 影院信息
    async getInfo(movieId, cityId) {
        const { cinemaId, theMovie, cur_city, dispatch } = this.props;

        try {
            const res = await get('getTimeCinemaMovieVO', { cinemaId, cityId: cityId || cur_city.cityId }, true);

            let movie = {};

            if (movieId) {
                // 选择当前影片
                res.data.movieList.forEach(item => {
                    if (item.movieId == movieId) {
                        movie = item;
                    }
                });
            } else {
                // （搜索进入)取第二个影片
                movie = res.data.movieList[0];
            }

            this.setState({
                cinemaInfoVO: res.data.cinemaInfoVO,
                movieList: res.data.movieList,
                theMovie: movie,
                hasError: false
            });
            // 接入辅营活动需要的品牌和是否是新用户的规则获取start
            dispatch({
                type: 'brandId_change',
                brandId: res.data.cinemaInfoVO.brandId
            });
            dispatch({
                type: 'newUser_change',
                newUser: res.data.newUser
            });
            saveLocal('brandId', res.data.cinemaInfoVO.brandId);
            saveLocal('newUser', res.data.newUser);
            // 接入辅营活动需要的品牌和是否是新用户的规则获取end
            this.getMovieDate(cinemaId, movie.movieId);

            if(!cinemaId || !(cityId || cur_city.cityId)){
                sgmReport('1001', {function_id: 'getTimeCinemaMovieVO',message:'缺少参数cinemaId/cityId'}, 3)
            }
        } catch (e) {
            this.setState({
                hasError: true
            });
        }
    }

    getMovieDate(cinemaId, movieId) {
        // const { theDate } = this.state;
        const theDate = fetchLocal('TheDate');

        get('getMovieIssueShowDate', {
            cinemaId,
            movieId
        }, true).then((res) => {
            // 影片日期存在取影片日期  搜索进入（日期不存在)取第一个日期
            let getDate = theDate || res.data?.showTimes[0]?.split(',')[1];

            // 判断当前选择的日期在当前影片排期中是否存在
            if (theDate) {
                let hasTheDate;

                res.data.showTimes.forEach((val) => {
                    const valDate = val?.split(',');

                    if ((valDate[1] == theDate) && !hasTheDate) {
                        hasTheDate = true;
                    }
                });
                !hasTheDate && (getDate = res.data?.showTimes[0]?.split(',')[1]);
            }

            this.setState({
                showTimes: res.data.showTimes,
                theDate: getDate,
                loading: true,
                hasError: false
            });

            this.getMovieList(getDate);
        }).catch(() => {
            this.setState({
                hasError: true
            });
        });

        if(!cinemaId || !movieId){
            sgmReport('1001', {function_id: 'getMovieIssueShowDate',message:'缺少参数cinemaId/movieId'}, 3)
        }
    }

    getMovieList(theDate) {
        const { cinemaInfoVO, theMovie, showTimes, movieList } = this.state;

        this.setState({
            listLoading: false,
            dataLoading: true,
            promoTypes: []
        });

        post('getTimeIssuePlanVO', {
            cinemaId: cinemaInfoVO.cinemaId,
            cityId: cinemaInfoVO.cityId,
            date: theDate,
            movieId: theMovie.movieId
        }, true).then((res) => {
            const promoTypes = res.data && res.data.promoTypes ? res.data.promoTypes : [];

            const govSubsidy = res?.data?.govSubsidy;
            const govSubsidyText = res?.data?.govSubsidyText;
            const govSubsidyTag = res?.data?.govSubsidyTag;

            /* 格式化传过来的促销信息  {1:20,2:20} */
            // if(res.data.promoTypes){
            //     for( var key in res.data.promoTypes){
            //         promoTypes.push({
            //             promoType: key, //促销类型
            //             promoPrice: res.data.promoTypes[key] //促销金额
            //         })
            //     }
            // }

            // /* 格式化传过来的促销信息[促销格式变更]  {1:[20,20],2:20} */   后端又修改了！！！！！！！！！！！！！
            // if (res.data && res.data.promoTypes) {
            //     for (var key in res.data.promoTypes) {

            //         res.data.promoTypes[key].forEach((val) => {
            //             promoTypes.push({
            //                 promoType: key, //促销类型
            //                 promoPrice: val / 100 //促销金额
            //             })
            //         })
            //     }
            // };

            /* 当前无场次 设置选择明天或周六 */
            if (!res.data || res.data.plansVOS.length <= 0) {
                let nextIndex = 0;

                let nextDate = theDate;

                showTimes.forEach((val, inx) => {
                    if (theDate == val?.split(',')[1]) {
                        nextIndex = (inx + 1);
                    }
                });

                this.setState({
                    nextDate: null,
                    btnTxt: null
                });

                if (showTimes[nextIndex]) {
                    nextDate = showTimes[nextIndex]?.split(',')[1];
                    const btnTxt = diff_date(nextDate, new Date()) < 3 ? ['明天', '后天'][diff_date(nextDate, new Date()) - 1] : date_str(nextDate, true).slice(5);

                    this.setState({
                        nextDate,
                        btnTxt
                    });
                }
            }

            /* 分享信息 */
            const shareInfo = {
                url: `https://h5-movie.jd.com/movieList?cinemaId=${cinemaInfoVO.cinemaId}`,
                title: `一起去${cinemaInfoVO.cinemaName}身临其境可好？`,
                msg: res.data.promoTypes.length > 0 ? '现在来京东选座购票立享优惠！看电影，上京东！' : cinemaInfoVO.address
            };
            window.jdShare?.setShareInfo({
                title: `一起去${cinemaInfoVO.cinemaName}身临其境可好？`,
                content: res.data.promoTypes.length > 0 ? '现在来京东选座购票立享优惠！看电影，上京东！' : cinemaInfoVO.address,
                url: window.location.href,
                img: 'https://storage.jd.com/ltmovie/movieLogo.jpg',
                channel: '',
                callback: null
            })


            this.setState({
                // planList: [],
                planList: res.data ? res.data.plansVOS : [],
                listLoading: true,
                hasError: false,
                promoTypes,
                promoDesc: res.data && res.data.promoDesc ? res.data.promoDesc : '',
                shareInfo,
                ruleIds: res.data ? res.data.ruleIds : [],
                govSubsidy,
                govSubsidyText,
                govSubsidyTag
            });
        }).catch(() => {
            this.setState({
                planList: [],
                listLoading: true,
                hasError: false
            });
        });

        if(!cinemaInfoVO.cinemaId || !cinemaInfoVO.cityId || !theMovie.movieId){
            sgmReport('1001', {function_id: 'getTimeIssuePlanVO',message:'缺少参数cinemaId/cityId/movieId'}, 3)
        }
    }

    nextDate() {
        const { nextDate, showTimes } = this.state;

        let isInDay = false;

        showTimes.forEach((val) => {
            const valDate = val?.split(',');

            if ((valDate[1] == nextDate)) {
                isInDay = true;
            }
        });

        if (isInDay) {
            this.setState({
                theDate: nextDate
            });
        } else {
            this.setState({
                theDate: showTimes[0]?.split(',')[1]
            });
        }

        this.getMovieList(isInDay ? nextDate : showTimes[0]?.split(',')[1]);
    }

    refresh() {
        // const { theMovieId } = this.state;
        const { movieId } = this.props;

        this.setState({
            hasError: false,
            loading: false
        });
        this.getInfo(movieId);
    }

    /* 修改影片ID */
    _setMovieId(movie, movieId, picUrl) {
        const { cinemaId } = this.props;

        this.setState({
            theMovie: movie,
            theMovieId: movieId,
            picUrl,
            dataLoading: false,
            listLoading: false
        });
        // if(theMovie.movieId == movie.movieId)return
        this.getMovieDate(cinemaId, movieId);
        // this.getInfo(movieId)
    }

    _goBuy(item) {
        const { theMovie, theDate, cinemaInfoVO, govSubsidy, govSubsidyText, govSubsidyTag } = this.state;

        const seat = {
            planId: item.planId, // 场次id
            movieId: theMovie.movieId, // 影片id
            title: cinemaInfoVO.cinemaName, // 影院名称
            movieName: theMovie.movieName, // 影片名称
            theDate: theDate, // 选择日期 [2018-8-27]
            startTime: item.startTime, // 影片开始时间 [13:00]
            playType: item.playType, // 影片信息（3d/2d)
            hallName: item.hallName, // 影厅信息（几号厅）
            promtId: item.promtId, // 促销id
            // 三方唤起参数
            jdreactkey: 'JDReactMovie',
            jdreactapp: 'JDReactMovie',
            transparentenable: true,
            govSubsidy,
            govSubsidyText,
            govSubsidyTag
        };

        const that = this;

        JDLogin.isLogin().then(() => {
            // 是否登录_促销ID_开场时间（格式2018-11-12 15:30:00）_电影类型（后台下发）_影厅信息（后台下发）
            mta('TicketBuy', 'Detail', `是_${item.promtId}_${theDate} ${item.startTime}:00_${item.playType}_${item.hallName}`, `${theMovie.jSkuId}`);
            jump(that);
        }, () => {
            mta('TicketBuy', 'Detail', `否_${item.promtId}_${theDate} ${item.startTime}:00_${item.playType}_${item.hallName}`, `${theMovie.jSkuId}`);

            JDLogin.doLogin().then(() => {
                jump(that);
            });
        }).catch(() => jump());

        const { channel, buyFrom } = this.props;

        function jump(that) {
            that.setState({
                isLogin: true
            });
            that.context.router.toSeat(seat);
        }
    }

    _login() {
        JDLogin.doLogin().then((rs) => {
            this.setState({
                isLogin: true
            });
            const { cinemaId } = this.props;
            const { theMovie } = this.state;
            // if(theMovie.movieId == movie.movieId)return

            this.getMovieDate(cinemaId, theMovie.movieId);
        }, () => {
            JDLogin.doLogin().then(() => {
                this.setState({
                    isLogin: true
                });
            });
        });
    }

    _changeDate(arg) {
        const { theMovie } = this.state;
        const { jSkuId } = theMovie;
        // 日期_促销ID

        mta('TicketDateTab', 'Detail', `${arg}_null`, `${jSkuId}`);

        // alert(arg) 2019-09-06
        if (arg == this.state.theDate) return;
        this.setState({
            theDate: arg
        });
        this.getMovieList(arg);
        saveLocal('TheDate', arg); // 状态存储
    }

    setTitle = (title) => {
        document.title = title;
    }
}

MovieList.contextTypes = {
    router: PropTypes.object
};

const select = (state) => {
    const props = state.index;

    return {
        userPin: props.userPin,
        cur_city: props.cur_city
    };
};

export default connect(select, null, null, { withRef: true })(MovieList);